import React from "react";
import { withRouter } from "react-router-dom";

import { ArrowLightIcon } from "@pages/casino/assets/icons";
import { SearchModal } from "@pages/casino/containers";

import { BreadCrumbContainer, Title, TitleWrapper } from "./elements.js";
import useController from "./useController.js";

const Breadcrumb = ({ showSearch, urlKey, tab, history, onSearchToggle, ...props }) => {
	const {
		helpers: { translate },
		handlers: { handleClick },
	} = useController({ history, urlKey, tab });

	const renderButtonName = (tab) => {
		switch (tab) {
			case "casino":
				return translate("Back to Casino");
			case "livecasino":
				return translate("Back to Live Casino");
			default:
				return translate("Back");
		}
	};

	return (
		<BreadCrumbContainer {...props}>
			<TitleWrapper data-testid="button-filtered-casino-back" onClick={handleClick}>
				<ArrowLightIcon />
				<Title>{renderButtonName(tab)}</Title>
			</TitleWrapper>

			{showSearch && <SearchModal onSearchToggle={onSearchToggle} />}
		</BreadCrumbContainer>
	);
};

export default withRouter(Breadcrumb);
